// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import constants from '../SMSNotification.constants';
import { isCanada } from '../../../../../../../utils';
import ConfirmationSelectors from '../../../container/Confirmation.selectors';

const { getOrderConfirmation } = ConfirmationSelectors;

const getChildrenPalaceKey = (state) => {
  const selector = formValueSelector(constants.FORM_NAME);
  return selector(state, 'brandTCP');
};

const getGymboreeKey = (state) => {
  const selector = formValueSelector(constants.FORM_NAME);
  return selector(state, 'brandGYM');
};

const getSNJKey = (state) => {
  const selector = formValueSelector(constants.FORM_NAME);
  return selector(state, 'brandSNJ');
};

const getPJPKey = (state) => {
  const selector = formValueSelector(constants.FORM_NAME);
  return selector(state, 'brandPJP');
};

const getNotificationMsgContentInfo = () => {
  let notificationContent;
  const notificationMsg = isCanada()
    ? constants.Notification_Carrier_Message_CA
    : constants.Notification_Carrier_Message_US;
  const { referred } = getDynamicLabelValues('checkout.orderConfirmation');
  if (Array.isArray(referred)) {
    notificationContent =
      referred.length &&
      referred.find((label) => {
        return label.name === notificationMsg;
      });
  }
  return notificationContent;
};

const getNotificationRichTextSelector = (state) => {
  const rContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX.name === getNotificationMsgContentInfo().name
  );
  return rContent && rContent.richText;
};

const getSubscribeSuccessMsgContentInfo = () => {
  let notificationSuccessMsgID;
  const { referred } = getDynamicLabelValues('checkout.orderConfirmation');
  if (Array.isArray(referred)) {
    notificationSuccessMsgID =
      referred.length &&
      referred.find((label) => {
        return label.name === constants.Notification_Success_Msg;
      });
  }
  return notificationSuccessMsgID;
};

const getSubscribeSuccessMsgRichTextSelector = (state) => {
  const rContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) => moduleX.name === getSubscribeSuccessMsgContentInfo().name
  );
  return rContent && rContent.richText;
};

/**
 * re-select selector to provide create account success value
 */
const getSmsNotificationSuccess = createSelector(
  getOrderConfirmation,
  (orderConfirmation) => orderConfirmation && orderConfirmation.smsNotificationSuccess
);

const getSmsNotificationError = createSelector(
  getOrderConfirmation,
  (orderConfirmation) => orderConfirmation && orderConfirmation.error
);

const getOdmLoading = (state) => {
  return state.Confirmation && state.Confirmation.get('isLoading');
};

export default {
  getChildrenPalaceKey,
  getGymboreeKey,
  getSNJKey,
  getNotificationRichTextSelector,
  getNotificationMsgContentInfo,
  getSubscribeSuccessMsgRichTextSelector,
  getSubscribeSuccessMsgContentInfo,
  getOdmLoading,
  getSmsNotificationSuccess,
  getSmsNotificationError,
  getPJPKey,
};
